/**
 * @generated SignedSource<<189abeecd295261098875a51399a9be0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IntegrationLinkFindExistingIssueQuery$variables = {
  query: string;
};
export type IntegrationLinkFindExistingIssueQuery$data = {
  readonly viewer: {
    readonly jiraSearch: ReadonlyArray<{
      readonly externalId: string;
      readonly id: string;
      readonly img: string;
      readonly key: string;
      readonly summary: string;
    }>;
  };
};
export type IntegrationLinkFindExistingIssueQuery = {
  response: IntegrationLinkFindExistingIssueQuery$data;
  variables: IntegrationLinkFindExistingIssueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "text",
      "variableName": "query"
    }
  ],
  "concreteType": "JiraIssueSearchResult",
  "kind": "LinkedField",
  "name": "jiraSearch",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "img",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationLinkFindExistingIssueQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationLinkFindExistingIssueQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b7918ef0998884521d20aa6e78a4eaa2",
    "id": null,
    "metadata": {},
    "name": "IntegrationLinkFindExistingIssueQuery",
    "operationKind": "query",
    "text": "query IntegrationLinkFindExistingIssueQuery(\n  $query: String!\n) {\n  viewer {\n    jiraSearch(text: $query) {\n      id\n      key\n      img\n      summary\n      externalId\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5eb3a2ec8c41cbe5202417cc521f8932";

export default node;
